//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './WarrantyRequestClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type RequestDeviceWarrantyRequestQueryParameters = {
  serialNumber?: string | undefined ;
  serviceProduct?: string | null | undefined ;
  failureDuringTherapy?: boolean | null | undefined ;
  noFailureDuringTherapy?: boolean | null | undefined ;
  offset?: number | null | undefined ;
  limit?: number | null | undefined ;
  sortBy?: string | null | undefined ;
  sortOrder?: Types.SortOrder | undefined ;
  language?: string | undefined ;
}

export type SearchReplacementPartWarrantyRequestQueryParameters = {
  replacementPartArticle?: string | null | undefined ;
}


export function requestDeviceUrl(serialNumber?: string | undefined, serviceProduct?: string | null | undefined, failureDuringTherapy?: boolean | null | undefined, noFailureDuringTherapy?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, language?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/warranty-request?";
if (serialNumber === null)
    throw new Error("The parameter 'serialNumber' cannot be null.");
else if (serialNumber !== undefined)
    url_ += "SerialNumber=" + encodeURIComponent("" + serialNumber) + "&";
if (serviceProduct !== undefined && serviceProduct !== null)
    url_ += "ServiceProduct=" + encodeURIComponent("" + serviceProduct) + "&";
if (failureDuringTherapy !== undefined && failureDuringTherapy !== null)
    url_ += "FailureDuringTherapy=" + encodeURIComponent("" + failureDuringTherapy) + "&";
if (noFailureDuringTherapy !== undefined && noFailureDuringTherapy !== null)
    url_ += "NoFailureDuringTherapy=" + encodeURIComponent("" + noFailureDuringTherapy) + "&";
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
if (language === null)
    throw new Error("The parameter 'language' cannot be null.");
else if (language !== undefined)
    url_ += "language=" + encodeURIComponent("" + language) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let requestDeviceDefaultOptions: Omit<UseQueryOptions<Types.WarrantyResponseDto, unknown, Types.WarrantyResponseDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.WarrantyResponseDto, unknown, Types.WarrantyResponseDto>, 'queryFn'>> = {
};
export function getRequestDeviceDefaultOptions() {
  return requestDeviceDefaultOptions;
};
export function setRequestDeviceDefaultOptions(options: typeof requestDeviceDefaultOptions) {
  requestDeviceDefaultOptions = options;
}

export function requestDeviceQueryKey(dto: RequestDeviceWarrantyRequestQueryParameters): QueryKey;
export function requestDeviceQueryKey(serialNumber?: string | undefined, serviceProduct?: string | null | undefined, failureDuringTherapy?: boolean | null | undefined, noFailureDuringTherapy?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, language?: string | undefined): QueryKey;
export function requestDeviceQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { serialNumber, serviceProduct, failureDuringTherapy, noFailureDuringTherapy, offset, limit, sortBy, sortOrder, language,  } = params[0] as RequestDeviceWarrantyRequestQueryParameters;

    return trimArrayEnd([
        'WarrantyRequestClient',
        'requestDevice',
        serialNumber as any,
        serviceProduct as any,
        failureDuringTherapy as any,
        noFailureDuringTherapy as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
        language as any,
      ]);
  } else {
    return trimArrayEnd([
        'WarrantyRequestClient',
        'requestDevice',
        ...params
      ]);
  }
}
export function __requestDevice(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.requestDevice(
      context.queryKey[2] as string | undefined,       context.queryKey[3] as string | null | undefined,       context.queryKey[4] as boolean | null | undefined,       context.queryKey[5] as boolean | null | undefined,       context.queryKey[6] as number | null | undefined,       context.queryKey[7] as number | null | undefined,       context.queryKey[8] as string | null | undefined,       context.queryKey[9] as Types.SortOrder | undefined,       context.queryKey[10] as string | undefined,axiosConfig    );
}

export function useRequestDeviceQuery<TSelectData = Types.WarrantyResponseDto, TError = unknown>(dto: RequestDeviceWarrantyRequestQueryParameters, options?: Omit<UseQueryOptions<Types.WarrantyResponseDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Request device
 * @param serialNumber (optional) Serial number of the desired  device (seriennummer)
 * @param serviceProduct (optional) Service product number (serprod)
Using when we want to select between device with same serial number
 * @param failureDuringTherapy (optional) Failure during therapy (kybausfther)
 * @param noFailureDuringTherapy (optional) No failure during therapy (kybnausfther)
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 * @param language (optional) 
 */
export function useRequestDeviceQuery<TSelectData = Types.WarrantyResponseDto, TError = unknown>(serialNumber?: string | undefined, serviceProduct?: string | null | undefined, failureDuringTherapy?: boolean | null | undefined, noFailureDuringTherapy?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, language?: string | undefined, options?: Omit<UseQueryOptions<Types.WarrantyResponseDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useRequestDeviceQuery<TSelectData = Types.WarrantyResponseDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.WarrantyResponseDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let serialNumber: any = undefined;
  let serviceProduct: any = undefined;
  let failureDuringTherapy: any = undefined;
  let noFailureDuringTherapy: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  let language: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ serialNumber, serviceProduct, failureDuringTherapy, noFailureDuringTherapy, offset, limit, sortBy, sortOrder, language,  } = params[0] as RequestDeviceWarrantyRequestQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [serialNumber, serviceProduct, failureDuringTherapy, noFailureDuringTherapy, offset, limit, sortBy, sortOrder, language, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.WarrantyResponseDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __requestDevice(context, axiosConfig) : __requestDevice,
    queryKey: requestDeviceQueryKey(serialNumber, serviceProduct, failureDuringTherapy, noFailureDuringTherapy, offset, limit, sortBy, sortOrder, language),
    ...requestDeviceDefaultOptions as unknown as Omit<UseQueryOptions<Types.WarrantyResponseDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Request device
 * @param serialNumber (optional) Serial number of the desired  device (seriennummer)
 * @param serviceProduct (optional) Service product number (serprod)
Using when we want to select between device with same serial number
 * @param failureDuringTherapy (optional) Failure during therapy (kybausfther)
 * @param noFailureDuringTherapy (optional) No failure during therapy (kybnausfther)
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 * @param language (optional) 
 */
export function setRequestDeviceData(queryClient: QueryClient, updater: (data: Types.WarrantyResponseDto | undefined) => Types.WarrantyResponseDto, serialNumber?: string | undefined, serviceProduct?: string | null | undefined, failureDuringTherapy?: boolean | null | undefined, noFailureDuringTherapy?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, language?: string | undefined) {
  queryClient.setQueryData(requestDeviceQueryKey(serialNumber, serviceProduct, failureDuringTherapy, noFailureDuringTherapy, offset, limit, sortBy, sortOrder, language),
    updater
  );
}

/**
 * Request device
 * @param serialNumber (optional) Serial number of the desired  device (seriennummer)
 * @param serviceProduct (optional) Service product number (serprod)
Using when we want to select between device with same serial number
 * @param failureDuringTherapy (optional) Failure during therapy (kybausfther)
 * @param noFailureDuringTherapy (optional) No failure during therapy (kybnausfther)
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 * @param language (optional) 
 */
export function setRequestDeviceDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.WarrantyResponseDto | undefined) => Types.WarrantyResponseDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function searchReplacementPartUrl(replacementPartArticle?: string | null | undefined): string {
  let url_ = getBaseUrl() + "/api/warranty-request/replacement-part?";
if (replacementPartArticle !== undefined && replacementPartArticle !== null)
    url_ += "ReplacementPartArticle=" + encodeURIComponent("" + replacementPartArticle) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let searchReplacementPartDefaultOptions: Omit<UseQueryOptions<Types.ReplacementPartResponseDto, unknown, Types.ReplacementPartResponseDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ReplacementPartResponseDto, unknown, Types.ReplacementPartResponseDto>, 'queryFn'>> = {
};
export function getSearchReplacementPartDefaultOptions() {
  return searchReplacementPartDefaultOptions;
};
export function setSearchReplacementPartDefaultOptions(options: typeof searchReplacementPartDefaultOptions) {
  searchReplacementPartDefaultOptions = options;
}

export function searchReplacementPartQueryKey(replacementPartArticle?: string | null | undefined): QueryKey;
export function searchReplacementPartQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { replacementPartArticle,  } = params[0] as SearchReplacementPartWarrantyRequestQueryParameters;

    return trimArrayEnd([
        'WarrantyRequestClient',
        'searchReplacementPart',
        replacementPartArticle as any,
      ]);
  } else {
    return trimArrayEnd([
        'WarrantyRequestClient',
        'searchReplacementPart',
        ...params
      ]);
  }
}
export function __searchReplacementPart(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.searchReplacementPart(
      context.queryKey[2] as string | null | undefined,axiosConfig    );
}

export function useSearchReplacementPartQuery<TSelectData = Types.ReplacementPartResponseDto, TError = unknown>(dto: SearchReplacementPartWarrantyRequestQueryParameters, options?: Omit<UseQueryOptions<Types.ReplacementPartResponseDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Search replacement part nubmer
 * @param replacementPartArticle (optional) replacement part article (tersatzteil)
 */
export function useSearchReplacementPartQuery<TSelectData = Types.ReplacementPartResponseDto, TError = unknown>(replacementPartArticle?: string | null | undefined, options?: Omit<UseQueryOptions<Types.ReplacementPartResponseDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useSearchReplacementPartQuery<TSelectData = Types.ReplacementPartResponseDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ReplacementPartResponseDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let replacementPartArticle: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ replacementPartArticle,  } = params[0] as SearchReplacementPartWarrantyRequestQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [replacementPartArticle, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ReplacementPartResponseDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __searchReplacementPart(context, axiosConfig) : __searchReplacementPart,
    queryKey: searchReplacementPartQueryKey(replacementPartArticle),
    ...searchReplacementPartDefaultOptions as unknown as Omit<UseQueryOptions<Types.ReplacementPartResponseDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Search replacement part nubmer
 * @param replacementPartArticle (optional) replacement part article (tersatzteil)
 */
export function setSearchReplacementPartData(queryClient: QueryClient, updater: (data: Types.ReplacementPartResponseDto | undefined) => Types.ReplacementPartResponseDto, replacementPartArticle?: string | null | undefined) {
  queryClient.setQueryData(searchReplacementPartQueryKey(replacementPartArticle),
    updater
  );
}

/**
 * Search replacement part nubmer
 * @param replacementPartArticle (optional) replacement part article (tersatzteil)
 */
export function setSearchReplacementPartDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ReplacementPartResponseDto | undefined) => Types.ReplacementPartResponseDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function addToBasketDefaultUrl(): string {
  let url_ = getBaseUrl() + "/api/warranty-request/default";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function addToBasketDefaultMutationKey(): MutationKey {
  return trimArrayEnd([
      'WarrantyRequestClient',
      'addToBasketDefault',
    ]);
}

/**
 * Add to basket default device
 */
export function useAddToBasketDefaultMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.FillDefaultWarrantyRequestDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.FillDefaultWarrantyRequestDto, TContext> {
  const key = addToBasketDefaultMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (request: Types.FillDefaultWarrantyRequestDto) => Client.addToBasketDefault(request),
    mutationKey: key,
  });
}
  
export function addToBasketWithSameNumUrl(): string {
  let url_ = getBaseUrl() + "/api/warranty-request/same-serial-number";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function addToBasketWithSameNumMutationKey(): MutationKey {
  return trimArrayEnd([
      'WarrantyRequestClient',
      'addToBasketWithSameNum',
    ]);
}

/**
 * Add to basket one of devices with the smae serial number
 */
export function useAddToBasketWithSameNumMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.FillWarrantyRequestSameNumDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.FillWarrantyRequestSameNumDto, TContext> {
  const key = addToBasketWithSameNumMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (request: Types.FillWarrantyRequestSameNumDto) => Client.addToBasketWithSameNum(request),
    mutationKey: key,
  });
}
  
export function addToBasketSpecialUrl(): string {
  let url_ = getBaseUrl() + "/api/warranty-request/special";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function addToBasketSpecialMutationKey(): MutationKey {
  return trimArrayEnd([
      'WarrantyRequestClient',
      'addToBasketSpecial',
    ]);
}

/**
 * Add to basket special device
 */
export function useAddToBasketSpecialMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.FillSpecialWarrantyRequestDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.FillSpecialWarrantyRequestDto, TContext> {
  const key = addToBasketSpecialMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (request: Types.FillSpecialWarrantyRequestDto) => Client.addToBasketSpecial(request),
    mutationKey: key,
  });
}